import React from 'react'

export default function WikipediaCheckbox(props) {
  const { active, handleActiveChange, field, Id } = props
  return (
    <div>
      {field === 'movieName' ? (
        <div>
          <div className='tinput'>
            <div
              className='currentlyactive-style'
              style={{ display: 'flex', gap: '10px', position: 'relative' }}
            >
              <input
                id={`${Id}`}
                type='checkbox'
                name='currently active'
                checked={active[field] === 'TRUE'}
                onChange={event => handleActiveChange(event, `${field}`)}
              />
              <label htmlFor={`${Id}`}>OK</label>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ position: 'relative', bottom: '35px' }}>
          <div className='tinput'>
            <div
              className='currentlyactive-style'
              style={{ display: 'flex', gap: '10px', position: 'relative', top: '35px' }}
            >
              <input
                id={`${Id}`}
                type='checkbox'
                name='currently active'
                checked={active[field] === 'TRUE'}
                onChange={event => handleActiveChange(event, `${field}`)}
              />
              <label htmlFor={`c${Id}`}>OK</label>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
